import Vue from 'vue'
import store from '../store'
import axios from 'axios'

const vueObj = new Vue()

const state = {
  isFetching: false,
  isRemoving: false,
  isSaving: false,
  isSavingNewCard: false,
  showModal: false,
  payment: null,
  tmpOmiseChargeId: null,
  tmpOmiseToken: null,
  tmpIsDefaultCard: false,
  qrPaymentId: null
}

const actions = {
  LOAD_PAYMENT_DETAIL: ({ commit }, id) => {
    commit('REQUEST_PAYMENT_DATA')
    const submitData = { user_id: id }
    Vue.http.get('payments', { params: submitData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_PAYMENT_DETAIL', response)
        } else {
          commit('SET_PAYMENT_DETAIL', null)
        }
      })
  },
  ADD_PAYMENT: async ({ commit, rootState }, submitData) => {
    commit('REQUEST_SAVE_PAYMENT')
    const url = 'payments'
    const {data} = await axios.post(url, submitData)
    commit('FINISH_REQUEST_SAVE_PAYMENT')
    if (!data.error) {
      commit('SET_MODAL_DISPLAY', false)
      commit('SET_TMP_OMISE_TOKEN', null)
      commit('SET_PAYMENT_DETAIL', data)
      if (data.user_credit_card && data.user_credit_card.is_default) {
        const omiseCustomerId = data.omise_customer_id
        const preCheckoutData = {
          key: 'omise_customer_id',
          value: omiseCustomerId
        }
        // console.log('ADD_PAYMENT omiseCustomerId', omiseCustomerId)
        if (!rootState.serviceRequest.tmpConfirmPaymentData) {
          store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', preCheckoutData)
        }
      }
    } else {
      const alertText = 'Payment error: ' + data.message
      vueObj.$swal('Oops!', alertText, 'error')
    }
  },
  SAVE_NEW_CARD: ({ commit }, submitData) => {
    commit('SET_SAVING_NEW_CARD', true)
    const url = 'payments'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_SAVING_NEW_CARD', false)
        } else {
          alert(response.message)
        }
      })
  },
  REMOVE_PAYMENT: ({ commit }, id) => {
    commit('REQUEST_REMOVE_PAYMENT')
    const submitData = { user_id: id }
    Vue.http.delete('payments', { body: submitData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_REMOVE_PAYMENT')
        if (!response.error) {
          commit('SET_PAYMENT_DETAIL', null)
        } else {
          alert(response.message)
        }
      })
  }
}

const mutations = {
  REQUEST_PAYMENT_DATA: (state) => {
    state.isFetching = true
  },
  FINISH_REQUEST_DATA: (state) => {
    state.isFetching = false
  },
  SET_PAYMENT_DETAIL: (state, payment) => {
    state.isFetching = false
    state.payment = payment
  },
  SET_PAYMENT: (state, data) => {
    state.payment = data
  },
  SET_MODAL_DISPLAY: (state, status) => {
    state.isFetching = false
    state.showModal = status
  },
  REQUEST_SAVE_PAYMENT: (state) => {
    state.isSaving = true
  },
  FINISH_REQUEST_SAVE_PAYMENT: (state) => {
    state.isSaving = false
  },
  REQUEST_REMOVE_PAYMENT: (state) => {
    state.isRemoving = true
  },
  FINISH_REMOVE_PAYMENT: (state) => {
    state.isRemoving = false
  },
  SET_SAVING_NEW_CARD: (state, status) => {
    state.isSavingNewCard = status
  },
  SET_TMP_OMISE_CHARGE_ID: (state, omiseChargeId) => {
    state.tmpOmiseChargeId = omiseChargeId
  },
  SET_TMP_OMISE_TOKEN: (state, token) => {
    state.tmpOmiseToken = token
  },
  SET_TMP_IS_DEFAULT_CARD: (state, isDefaultCard) => {
    state.tmpIsDefaultCard = isDefaultCard
  }
}

const getters = {
  getState: state => {
    return state
  },
  isAdding: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.add'
  },
  isRemoving: state => {
    return state.isRemoving ? 'message.removing' : 'message.remove'
  },
  getPayment: state => {
    return state.payment
  },
  isSaving: state => {
    return state.isSaving
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js